// File: User.js

import { API_BASE } from './ApiMaster';

export async function fetchUserByEmail(email) {
  try {
    const res = await fetch(`${API_BASE}/api/user/${encodeURIComponent(email)}`);
    if (!res.ok) throw new Error('Failed to fetch user');
    return await res.json();
  } catch (err) {
    console.error('fetchUserByEmail error:', err);
    return null;
  }
}

export async function createOrUpdateUser(userData) {
  try {
    const res = await fetch(`${API_BASE}/api/user`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(userData),
    });
    if (!res.ok) throw new Error('Failed to save user');
    return await res.json();
  } catch (err) {
    console.error('createOrUpdateUser error:', err);
    return null;
  }
}

export async function registerUserMeta(userProfile) {
  try {
    const res = await fetch(`${API_BASE}/api/meta/user`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(userProfile),
    });
    if (!res.ok) throw new Error('Meta user registration failed');
    return await res.json();
  } catch (err) {
    console.error('registerUserMeta error:', err);
    return null;
  }
}

export async function registerAppForUser(email, appName) {
  try {
    const res = await fetch(`${API_BASE}/api/meta/user/${encodeURIComponent(email)}/register_app`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ app: appName }),
    });
    if (!res.ok) throw new Error('App folder registration failed');
    return await res.json();
  } catch (err) {
    console.error('registerAppForUser error:', err);
    return null;
  }
}
